import React from 'react'
//image
import logo from "./Images/logo.png";
import facebook from "./Images/facebook.png";
import linkdin from "./Images/linkdin.svg";
import insta from "./Images/insta.png";
import youtube from "./Images/youtube.svg";
import google from "./Images/google.svg";
import appstore from "./Images/appstore.svg";
import testway from "./Images/testway.svg";
import forWayTest from './Images/4-way-test.png';
import logo2 from "./Images/RMB-Strip-Jaipur.png";

// icon
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";



const Footer = () => {
  return (
    <div>
        <div className='bg-[#0c3c7c] px-[8%] flex flex-wrap lg:flex-nowrap md:flex-wrap sm:flex-wrap w-100 py-[100px]'>
        <div className='lg:w-[80%] pt-1 md:w-[50%] sm:w-[90%] '>
          <a href="/"><img className="w-[100%] h-[59px] cursor-pointer	" src={logo2} alt="" /></a>
        <p className='font-[16px] text-[#CBD5E0] leading-5 text-justify  py-6
        '>Rotary Means Business (RMB) is an RI recognised Fellowship group of Rotarians established with a purpose of promoting fellowship and business networking among Rotarians.</p>
        <div className='flex gap-x-4 z-20'>
            <img className='w-6 h-6 cursor-pointer	' src={insta} alt="" onClick={()=>
              window.location.href="https://www.instagram.com/rotarymeansbusinessjaipur/"
            }/>
            <img className='w-6 h-6 cursor-pointer	' src={facebook} alt="" onClick={()=>
              window.location.href="https://www.facebook.com/RMBJaipur/"
            }/>
            <img className='w-6 h-6 cursor-pointer	' src={linkdin} alt="" onClick={()=>
              window.location.href="#"
            }/>
            <img className='w-6 h-6 cursor-pointer	' src={youtube} alt="" onClick={()=>
              window.location.href="https://www.youtube.com/channel/UCc82djijUfxVlxUEAMZlklQ"
            }/>
        </div>
        
        </div>
        <div className='w-[100%] md:pl-20 md:w-[50%] sm:w-[100%]  md:mt-0 mt-8 '>
        <h5 className='m-0 text-[20px] text-[#CBD5E0] font-semibold leading-5 pl-2 pb-2'>Official Info</h5>
        <div className='h-[1.5px] bg-[#FDBC12] w-[125px] mt-2'></div>
        <ul>
            <li className='flex items-center mt-3 	'> <FaPhoneAlt className='text-[16px] text-[#FDBC12] cursor-pointer'/>
           <span className='text-[13px] text-[#F5F5F5] pl-2  cursor-pointer	 ' >  +91 9214001400</span></li>
            
             
            <li className='flex items-center mt-3 	'> <FaEnvelope className='text-[16px] text-[#FDBC12] cursor-pointer	' />
           <span className='text-[13px] text-[#F5F5F5] pl-2  cursor-pointer	' > rotarymeansbuisnessjaipur@gmail.com</span></li>
           <li className='flex items-center mt-3 	'> <IoLocationSharp className='text-[30px] text-[#FDBC12] cursor-pointer	' />
           <span className='text-[13px] text-[#F5F5F5] pl-2 pr-2 cursor-pointer	' > 209- A, Windsor Plaza, Sansar Chandra Road, jaipur-30201(India)</span></li>
        </ul>
        </div>
        <div className='w-[100%] lg:pl-10 md:pl-0 md:w-[50%] md:mt-8 mt-8 lg:mt-0 sm:w-[100%]'>
        <h5 className='m-0 text-[20px] text-[#CBD5E0] font-semibold leading-5 pl-2 pb-2'>Quick Links</h5>
        <div className='h-[1.5px] bg-[#FDBC12] w-[125px] mt-2'></div>
        <ul>
            <li className='flex items-center mt-4'>
           <span className='text-[13px] text-[#F5F5F5] pl-2 cursor-pointer	 ' > <a href="/about"> About Us</a></span></li>
            <li className='flex items-center mt-4	'>
           <span className='text-[13px] text-[#F5F5F5] pl-2  cursor-pointer	' > <a href="/contact">Contact US</a> </span></li>
            
            <li className='flex items-center mt-4	'>
           <span className='text-[13px] text-[#F5F5F5] pl-2 cursor-pointer	 ' > <a href="/members">Members</a> </span></li>
           <li className='flex items-center mt-4	'>
           <span className='text-[13px] text-[#F5F5F5] pl-2  cursor-pointer	' > <a href="/directors">Director</a> </span></li>
        </ul>
        </div>
        <div className='w-[100%] flex flex-col   md:mt-8 mt-8 lg:mt-0 sm:w-[100%] md: items-start'>
        {/* <h5 className='m-0 text-[20px] text-[#CBD5E0] font-semibold leading-5 pl-2 pb-2 mr-8'>App Download</h5> */}
        {/* <div className='h-[1.5px] bg-[#FDBC12] w-[155px] mr-6 mt-2'></div> */}
        <ul>
           <li className=' cursor-pointer	'><img src={forWayTest} alt="" className='w-full h-full'/></li>
           
        </ul>
        </div>
        </div>
        <div className='text-center bg-[#CBD5E0] py-6'><p className='text-[16px] text-[#465468] font-normal	'>Design By < a href="https://aadviktech.com/">Aadvik Tech Services PVT. LTD</a></p> And Hosted By Aadvika Web</div>
    </div>
  )
}

export default Footer